import React, { useEffect, useRef, useState } from "react";
import { PhotographIcon } from "@heroicons/react/outline";

// Returns a pasted image file (e.g. a screenshot), or null when the clipboard
// holds text, so normal text pasting is never blocked.
export const imageFromClipboard = (e) => {
  const items = [...(e.clipboardData?.items || [])];
  if (items.some((item) => item.kind === "string" && item.type === "text/plain")) {
    return null;
  }
  const image = items.find(
    (item) => item.kind === "file" && item.type.startsWith("image/")
  );
  return image ? image.getAsFile() : null;
};

// Photo icon button with a hidden file input; calls onSelect with the file.
export const ImageAttachButton = ({ onSelect, disabled, className = "" }) => {
  const inputRef = useRef(null);

  return (
    <>
      <button
        type="button"
        className={`image-attach-button ${className}`}
        onClick={(e) => {
          // Drop focus after a mouse/touch click so no focus ring is left
          // behind once the file picker closes; keyboard users keep it.
          if (e.detail > 0) e.currentTarget.blur();
          inputRef.current?.click();
        }}
        disabled={disabled}
        title="Προσθήκη φωτογραφίας"
        aria-label="Προσθήκη φωτογραφίας"
      >
        <PhotographIcon className="image-attach-icon" />
      </button>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        hidden
        onChange={(e) => {
          const file = e.target.files?.[0];
          // Reset so picking the same file again still fires onChange.
          e.target.value = "";
          if (file) onSelect(file);
        }}
      />
    </>
  );
};

export const ImageAttachPreview = ({ file, onRemove, disabled }) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!file) {
      setUrl(null);
      return undefined;
    }
    const objectUrl = URL.createObjectURL(file);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  if (!url) return null;

  return (
    <div className={`image-attach-preview${disabled ? " is-busy" : ""}`}>
      <img src={url} alt="" />
      {!disabled && (
        <button
          type="button"
          onClick={onRemove}
          title="Αφαίρεση φωτογραφίας"
          aria-label="Αφαίρεση φωτογραφίας"
        >
          ×
        </button>
      )}
    </div>
  );
};
